import React from "react";
import classes from "./Footer.module.css";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import CopyrightIcon from "@mui/icons-material/Copyright";
import TwitterIcon from '@mui/icons-material/Twitter';

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <div className={classes.footer}>
      <ul>
        
        <li>
          <a href="https://twitter.com/japlatform" target="__blank"><TwitterIcon className={classes.twitter} fontSize="large" /></a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/journeyanalytics/" target="__blank"><LinkedInIcon className={classes.linkedin} fontSize="large" /></a>
        </li>
        <li>
          <a href="https://www.youtube.com/channel/UCxONXsudsDfRXIAEgKJ9mqQ/videos" target="__blank"><YouTubeIcon className={classes.youtube} fontSize="large" /></a>
        </li>
      </ul>
      <div className={classes.copyright}>
        <CopyrightIcon className={classes.copyLogo} />
        <span>{`${year} Journey Analytics. All rights reserved.`}</span>
      </div>
    </div>
  );
};

export default Footer;
